import React from 'react';
import tw from 'twin.macro';
import CardMain from '$/components/Interactions/cards/CardMain';
import { useCardContext } from '$/components/Interactions/cards/CardContext';
import { css } from '@emotion/react';
import { readableColorOnBackground } from '$/utils/colors';

export const ThinkificPromoCard: React.FC = () => {
  const { interaction } = useCardContext();
  if (!interaction.details) return null;

  return (
    <CardMain.StandardCard noDescription>
      {interaction.details?.subtitle && (
        <>
          {true ? (
            <CardMain.Subtitle
              css={css`
                ${tw`text-lg`}
                color: ${interaction.ewebinar?.primaryColor};
              `}
            >
              {interaction.subtitle()}
            </CardMain.Subtitle>
          ) : (
            <div className='flex justify-end'>
              <CardMain.Subtitle
                css={css`
                  background-color: ${interaction.ewebinar?.primaryColor};
                  color: ${readableColorOnBackground(interaction.ewebinar?.primaryColor ?? '#fff')};
                  border-top-left-radius: 10px;
                  border-bottom-left-radius: 10px;
                  padding: 5px 0.75rem 5px 1.5rem;
                  width: fit-content;
                  min-width: auto !important;
                  margin-right: -0.75rem;
                `}
              >
                {interaction.subtitle()}
              </CardMain.Subtitle>
            </div>
          )}
        </>
      )}
      <CardMain.Description>{interaction.description()}</CardMain.Description>
      <CardMain.ExpiresButton interaction={interaction} />
    </CardMain.StandardCard>
  );
};
